import "./Footer.css";
import { Link } from "react-router-dom";
import footerBg from "../../assets/footer/footer1.png";
import footerLogo from "../../assets/footer/Layer_1.png";

function Footer() {
  return (
    <div className="footer">
      <div
        className="footer-img"
        style={{ backgroundImage: `url(${footerBg})` }}
      ></div>
      <div className="footer-first">
        <div className="footer-logo">
          <img src={footerLogo} alt="footer" />
        </div>
        <div className="footer-links">
          <div>
            <h5>BOOKING PLAN</h5>
            <div className="links">
              <Link to="/packages" state={{ activeCategory: "Festival Tours" }}>
                Festival Tours
              </Link>
              <Link
                to="/packages"
                state={{ activeCategory: " Exploring the Highlands" }}
              >
                Highland Tours
              </Link>
              <Link
                to="/packages"
                state={{ activeCategory: "Trekking & Hiking Tours" }}
              >
                Hiking Tours
              </Link>
              <Link to="/packages" state={{ activeCategory: "Private Tours" }}>
                Private Tours
              </Link>
              <Link
                to="/packages"
                state={{ activeCategory: "Camping & Outdoor Adventure" }}
              >
                Camping Tours
              </Link>
            </div>
          </div>
          <div>
            <h5>CONNECT</h5>
            <div className="links">
              <a
                href="https://www.instagram.com/mystiquebht?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                target="_blank"
                rel="noopener noreferrer"
              >
                Instagram
              </a>
              <a
                href="https://wa.me/97577213835?text=Hello%2C%20I%20want%20to%20know%20more%20about%20your%20tours."
                target="_blank"
                rel="noopener noreferrer"
              >
                Whatsapp
              </a>
            </div>
          </div>
          <div>
            <h5>EXPLORE</h5>
            <div className="links">
              <Link to="/">Home</Link>
              <Link to="/about">About Us</Link>
              <Link to="/packages">Packages</Link>
            </div>
          </div>
          <div>
            <h5>CONTACT INFO</h5>
            <div className="links">
              <div>Paro, Bhutan</div>
              <div>+975-77213835</div>
              <div>Mystiquebht@gmail.com</div>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-second">
        <h2>JOIN THE SOUL OF THE HIMALAYA</h2>
      </div>
      <div className="footer-third">
        <div className="copyright">
          <div>© 2025 Mystique Bhutan. All Rights Reserved.</div>
          <div>Website by Ultra</div>
        </div>
        <div className="terms">
          <Link to={"/faqs"}>FAQs</Link>
          <Link to={"/privacy"}>Privacy</Link>
          <Link to={"/terms"}>Terms & Conditions</Link>
        </div>
      </div>
    </div>
  );
}

export default Footer;
